import { Component } from "react";

import { SummaryBarWithChange } from "./summaryWithChange";
import { DoublePivotBarChart } from "./tabBarChart";
import { DoublePivotPieChart } from "./tabPieChart";
import { DoublePivotTable } from "./tabTable";

export class DoublePivotTabBody extends Component {
    getTabChart(chartOptions) {
        const chartType = this.props.subModel.get("doublePivot").reactProps.chart;
        if (chartType === "pie") {
            return <DoublePivotPieChart {...chartOptions} />;
        }
        if (chartType === "table") {
            return <DoublePivotTable {...chartOptions} />;
        }
        return <DoublePivotBarChart {...chartOptions} />;
    }

    render() {
        const summaryOptions = {
            dateRanges: this.props.dateRanges,
            first_pivot_key: this.props.first_pivot_key,
            second_pivot_key: this.props.second_pivot_key,
            subModel: this.props.subModel,
            pivotName: this.props.pivotName,
            data: this.props.data,
            prevData: this.props.prevData,
            widgetSubType: this.props.widgetSubType,
            widgetQualifiers: this.props.widgetQualifiers
        };
    
        const chartOptions = {
            dateRanges: this.props.dateRanges, // really just used for drill through
            first_pivot_key: this.props.first_pivot_key, // really just  used for drill through
            second_pivot_key: this.props.second_pivot_key, // really just  used for drill through
            subModel: this.props.subModel, // really just used for drill through
            pivotName: this.props.pivotName,
            widgetSubType: this.props.widgetSubType,
            lineColors: this.props.lineColors,
            widgetQualifiers: this.props.widgetQualifiers, // really just  used for drill through
            widgetContainer: this.props.widgetContainer
        };
        return (
            <>
                <SummaryBarWithChange {...summaryOptions} />
                { this.getTabChart(chartOptions) }
            </>
        );
    }
}
